import { reduce } from "lodash"

/* sum up all time items to a number of seconds */
export const reduceTimeItemsToTime = items => reduce(items, (sum, { start, end }) => sum + (end - start), 0) / 1000
